import React from 'react'
import Appbar from './Appbar'
import { useTheme, useMediaQuery } from '@mui/material'
import PropTypes from 'prop-types'

const Layout = ({ displayName, children }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const mainContentStyle = {
    paddingTop: isMobile ? '56px' : '84px'
  }

  return (

        <div id="layout">
        <Appbar displayName={displayName}/>
        <main style={mainContentStyle} id="page">
        {children}
        </main>
        </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  displayName: PropTypes.string.isRequired
}

export default Layout
